import { Key, useState, useEffect } from 'react'
import clsx from 'clsx'
import { ProductsQuery } from 'lib/graphql/storeadmin'
import {
  Button,
  Card,
  Checkbox,
  Col,
  Empty,
  Icon,
  Image,
  Info,
  Modal,
  Paragraph,
  Row,
  Search,
  Skeleton,
  Text,
  Title,
  Tree,
  TreeNodeNormal,
} from 'components/common'

export type NodeType = {
  key: string
  title: string
  productName: string
}

export interface UnavailableItemsProps {
  loading?: boolean
  productsLoading?: boolean
  hasUnavailable?: boolean
  hideWarning?: boolean
  notForSaleData?: Key[]
  productData?: ProductsQuery
  selectedVariants?: NodeType[]
  setWarning?: (b: boolean) => void
  getProducts?: () => void
  handleSearch?: (e: string) => void
  onUnavailable?: (any) => void
  onHold?: () => void
  onDelete?: (any) => void
  onCheck?: (any) => void
  onSaved?: () => void
  openTree?: (data: ProductsQuery) => TreeNodeNormal[]
}

export const UnavailableItemsCard = ({
  loading,
  productsLoading,
  hasUnavailable,
  notForSaleData,
  onUnavailable,
  productData,
  getProducts,
  onHold,
  openTree,
  selectedVariants,
  onCheck,
  onDelete,
  onSaved,
  handleSearch,
  hideWarning,
  setWarning,
}: UnavailableItemsProps) => {
  const [showModal, setShowModal] = useState(false)
  const [checkedKeys, setCheckedKeys] = useState<Key[]>([])
  const [searchFiled, setSearchFiled] = useState<string>(null)
  const handleSearchBack = async () => {
    handleSearch(searchFiled)
    await getProducts()
  }
  const totalProducts = productData?.products?.totalCount
  // initializing data for checking keys in tree
  useEffect(() => {
    if (notForSaleData) {
      setCheckedKeys(notForSaleData)
    }
  }, [notForSaleData])

  // When Remove item, Unchecked the item.
  const unChecked = (uncheckedKey: Key) => {
    setCheckedKeys((value) => {
      return value?.filter((checkedKey) => checkedKey !== uncheckedKey)
    })
  }

  const onCheckBack = (keys: Key[]) => {
    setWarning(true)
    const filteredKeys = keys.filter((obj) => !obj.toString().includes('='))
    setCheckedKeys(filteredKeys)
    onCheck(filteredKeys)
  }
  return (
    <>
      <Card shadow loading={loading}>
        <Info title="この区分で利用不可な施設を登録することができます。">
          <Title level={5}>利用不可施設</Title>
        </Info>

        <Checkbox checked={hasUnavailable} onChange={onUnavailable}>
          この利用時間区分には利用不可な施設があります
        </Checkbox>

        {hasUnavailable && (
          <>
            <div
              className={clsx('flex', 'justify-start', 'items-center', 'mt-8')}
            >
              <Search
                autoComplete="off"
                placeholder="施設を検索する"
                value={searchFiled}
                onChange={(e) => setSearchFiled(e.target.value)}
                onSearch={handleSearch}
              />
              <Button
                className={clsx('ml-2')}
                onClick={() => {
                  handleSearchBack()
                  setShowModal(true)
                }}
              >
                閲覧する
              </Button>
            </div>

            <Modal
              title="施設を選択する"
              okText="OK"
              cancelText="閉じる"
              visible={showModal}
              onOk={() => {
                setShowModal(false)
                onHold()
              }}
              onCancel={() => {
                setShowModal(false)
              }}
              bodyStyle={{ height: 500, overflowY: 'scroll' }}
              okButtonProps={{ disabled: totalProducts === 0 }}
            >
              {totalProducts > 0 ? (
                <Tree
                  checkable
                  onCheck={onCheckBack}
                  checkedKeys={checkedKeys}
                  treeData={openTree(productData)}
                />
              ) : (
                <>
                  {loading || productsLoading ? (
                    <Skeleton paragraph={{ rows: 8 }} />
                  ) : (
                    <Empty />
                  )}
                </>
              )}
            </Modal>

            <div className={clsx('mt-8')}>
              {selectedVariants.map((variant) => (
                <Row key={variant.key} className={clsx('mb-3')}>
                  <Col className={clsx('flex', 'items-center')}>
                    <Image src="error" width={64} height={64} />
                  </Col>
                  <Col
                    className={clsx('flex', 'items-center')}
                    span={15}
                    offset={1}
                  >
                    <div>
                      <Paragraph strong style={{ marginBottom: '0.25rem' }}>
                        {variant.productName}
                      </Paragraph>
                      <Text mute>{variant.title}</Text>
                    </div>
                  </Col>
                  <Col
                    className={clsx('flex', 'items-center')}
                    span={3}
                    offset={1}
                  >
                    <Button
                      type={'link'}
                      style={{ padding: 0, top: 0 }}
                      onClick={() => {
                        unChecked(variant.key)
                        onDelete(variant.key)
                      }}
                    >
                      <Icon.CloseOutlined />
                    </Button>
                  </Col>
                </Row>
              ))}
              <div className={clsx('flex', 'item-top', 'justify-end')}>
                {selectedVariants?.length > 0 ? (
                  <div>
                    <div>
                      {hideWarning ? (
                        <Button
                          type="text"
                          danger
                          style={{
                            paddingRight: 0,
                            paddingLeft: 0,
                            paddingBottom: 6,
                          }}
                        >
                          * 保存ボタンを押してください
                        </Button>
                      ) : null}
                    </div>
                    <div className={clsx('flex', 'item-top', 'justify-end')}>
                      <Button
                        disabled={!hideWarning}
                        type={'primary'}
                        onClick={() => {
                          setWarning(false)
                          onSaved()
                        }}
                      >
                        保存する
                      </Button>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </>
        )}
      </Card>
    </>
  )
}
